export class ScholarshipType {
    public ID: number;
    public HashCode: string;
    public ScholarshipName: string;
    public yearID: number;
}